import React from 'react';

function OpenAccount() {
   return(
    <div className='container' style={{marginTop:"20px", display:"flex", flexDirection:"column", alignItems:"center", gap:"10px"}}>
        <h3>Open a Zerodha account</h3>
        <p>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
        <button >Sign up for free</button>
    </div>
   )
}

export default OpenAccount;